import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

interface ManagementSummaryCTAProps {
  clientId: string;
  isEmployee?: boolean;
}

export function ManagementSummaryCTA({ clientId, isEmployee }: ManagementSummaryCTAProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const path = isEmployee ? `/data-quality/${clientId}/reports/management-summary` : '/reports/management-summary';

  return (
    <div
      role="link"
      tabIndex={0}
      aria-label={t('value.mgmtSummaryTitle')}
      className="mgmt-cta flex items-center justify-between rounded-xl px-5 py-4"
      style={{
        background: 'linear-gradient(135deg, var(--primary), var(--primary-light))',
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(47, 90, 122, 0.15)',
      }}
      onClick={() => navigate(path)}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigate(path); } }}
    >
      <div className="flex items-center gap-3">
        <div
          className="flex h-10 w-10 items-center justify-center rounded-lg"
          style={{ backgroundColor: 'rgba(255,255,255,0.15)' }}
        >
          <span className="material-symbols-outlined" style={{ fontSize: '24px', color: 'white' }}>
            description
          </span>
        </div>
        <div>
          <p style={{ fontSize: '0.9375rem', fontWeight: 600, color: 'white' }}>
            {t('value.mgmtSummaryTitle')}
          </p>
          <p className="hidden sm:block" style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.8)' }}>
            {t('value.mgmtSummarySubtitle')}
          </p>
        </div>
      </div>
      <span className="material-symbols-outlined" style={{ fontSize: '20px', color: 'white' }}>
        chevron_right
      </span>

      <style>{`
        @media (prefers-reduced-motion: no-preference) {
          .mgmt-cta { transition: transform 200ms ease, box-shadow 200ms ease; }
          .mgmt-cta:hover { transform: translateY(-1px); box-shadow: 0 8px 25px rgba(47, 90, 122, 0.25); }
        }
      `}</style>
    </div>
  );
}
